<template>
  <modal-structure
    :affirmative-handler="handleAffirmative"
    :negative-handler="handleNegative"
  >
    <template v-slot:header>
      <h2 class="is-size-2 has-text-centered">
        {{ $t('domains.modal.title') }}
      </h2>
    </template>
    <template v-slot:content>
      <div>
        {{ $t('domains.modal.content') }}
      </div>
    </template>
    <template v-slot:footer />
  </modal-structure>
</template>

<script>
import ModalStructure from './ModalStructure'
export default {

  name: 'StandardConfirmation',
  components: {
    ModalStructure
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleAffirmative () {
      // go ahead with the functionality you want
    },
    handleNegative () {
      // console.log('you answered in the negative:')
    }
  }
}
</script>
